var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconMesComm = function SvgIconMesComm(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-mes-comm",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_97",
    "data-name": "Path 97",
    d: "M502.88 83.17h-4a6 6 0 0 0-1.334 11.847v4.153l4.667-4h.667a6 6 0 0 0 0-12Z",
    transform: "translate(-491.88 -81.17)",
    fill: "#bee6fa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15",
    "data-name": "Rectangle 15",
    width: 8,
    height: 2,
    rx: 1,
    transform: "translate(5 5)",
    fill: "#1eaae1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16",
    "data-name": "Rectangle 16",
    width: 6,
    height: 2,
    rx: 1,
    transform: "translate(5 9)",
    fill: "#1eaae1"
  }))));
};
export { SvgIconMesComm as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyBpZD0iaWNvbi1tZXMtY29tbSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB3aWR0aD0iMTgiIGhlaWdodD0iMTgiIHZpZXdCb3g9IjAgMCAxOCAxOCI+CiAgPHJlY3QgaWQ9ImFyZWEiIHdpZHRoPSIxOCIgaGVpZ2h0PSIxOCIgZmlsbD0iI2ViZWJlYiIgb3BhY2l0eT0iMCIvPgogIDxnIGlkPSJpY29uIj4KICAgIDxwYXRoIGlkPSJQYXRoXzk3IiBkYXRhLW5hbWU9IlBhdGggOTciIGQ9Ik01MDIuODgsODMuMTdoLTRhNiw2LDAsMCwwLTEuMzM0LDExLjg0N1Y5OS4xN2w0LjY2Ny00aC42NjdhNiw2LDAsMCwwLDAtMTJaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtNDkxLjg4IC04MS4xNykiIGZpbGw9IiNiZWU2ZmEiLz4KICAgIDxyZWN0IGlkPSJSZWN0YW5nbGVfMTUiIGRhdGEtbmFtZT0iUmVjdGFuZ2xlIDE1IiB3aWR0aD0iOCIgaGVpZ2h0PSIyIiByeD0iMSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNSA1KSIgZmlsbD0iIzFlYWFlMSIvPgogICAgPHJlY3QgaWQ9IlJlY3RhbmdsZV8xNiIgZGF0YS1uYW1lPSJSZWN0YW5nbGUgMTYiIHdpZHRoPSI2IiBoZWlnaHQ9IjIiIHJ4PSIxIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg1IDkpIiBmaWxsPSIjMWVhYWUxIi8+CiAgPC9nPgo8L3N2Zz4K";